import {
  Collapse,
  Paper,
  Tooltip,
  Typography,
  ListItem,
  Grid,
} from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { useAuthentication } from '../../context/authenticationContext'
import { operationUIContext } from '../../context/operationsContext'
import { makeStyles } from '@material-ui/core/styles'
import operationsService from '../../services/Operation/operationsService'
import { ExpandLess, ExpandMore } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  cabecera: {
    position: 'sticky',
    zIndex: '4',
    top: '49px',
    cursor: 'pointer',
    boxShadow: '0px 2px 4px rgb(0 0 0 / 15%)',
  },
  textFirst: {
    fontSize: '14px',
  },
  textData: {
    color: '#8f8f8f',
  },
  titleHeader: {
    fontWeight: '500',
    fontSize: '16px',
    maxWidth: '90%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wrapper: {
    padding: '5px 10px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  collapse: {
    padding: ' 10px 20px 20px 20px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
}))

export const CabeceraContext = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [operationData, setOperationData] = useState(null)
  const [nombreorganismo, setnombreorganismo] = useState(null)
  const { userToken } = useAuthentication()
  const valueUIContext = operationUIContext()
  const { operationID, operationLoanID } = valueUIContext

  useEffect(async () => {
    if (operationID && operationLoanID) {
      operationsService
        .postOne(operationID, operationLoanID, userToken)
        .then((operation) => {
          const { RetrieveLoanFulfillmentArrangementLoanDetailResponse } =
            operation
          try {
            const { Loan } =
              RetrieveLoanFulfillmentArrangementLoanDetailResponse || null
            setOperationData(Loan?.OperationName)
            setnombreorganismo(
              Loan?.Borrower[0].Jurisdiction[0].OrganisationName[0].LegalName,
            )
          } catch {}
        })
    }
  }, [operationID, operationLoanID])

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <>
      {operationData && (
        <Paper elevation="0" className={classes.cabecera}>
          <ListItem
            onClick={handleClick}
            style={{ justifyContent: 'space-between', paddingRight: '30px' }}
          >
            <Tooltip
              className={classes.wrapper}
              arrow
              title={operationData ? `${operationData}` : '...'}
            >
              <Typography className={classes.titleHeader}>
                {operationData ? `${operationData}` : ``}
              </Typography>
            </Tooltip>
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Grid container spacing={1} className={classes.collapse}>
              <Grid item xs={6}>
                <Typography className={classes.text}>
                  {operationData ? (
                    <div>
                      Número Operación:{' '}
                      <span className={classes.textData}>{operationID}</span>
                    </div>
                  ) : (
                    ``
                  )}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.text}>
                  {operationData ? (
                    <div>
                      Préstamo:{' '}
                      <span className={classes.textData}>
                        {operationLoanID}
                      </span>
                    </div>
                  ) : (
                    ``
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.text}>
                  {operationData ? (
                    <div>
                      Organismo:{' '}
                      <span className={classes.textData}>
                        {nombreorganismo}
                      </span>
                    </div>
                  ) : (
                    ``
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      )}
    </>
  )
}
